import { createContext, useContext } from 'react';
import type { PropsWithChildren, ReactNode } from 'react';

export const MessageNodeContext = createContext<ReactNode>(null);

export const MessageWrapper = ({ children }: PropsWithChildren) => {
	const messageNode = useContext(MessageNodeContext);
	return (
		<div>
			{children}
			{messageNode}
		</div>
	);
};
